module.exports = __webpack_public_path__ + "media/images/icons/share-dabe75e2309700915f4f43b9ceac5599.svg";